import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0.875C10.3815 0.875 13.125 3.61471 13.125 7C13.125 10.3853 10.3853 13.125 7 13.125C3.61471 13.125 0.875 10.3853 0.875 7C0.875 3.61471 3.61854 0.875 7 0.875ZM7.76467 9.29783H6.23533V10.8272H7.76467V9.29783ZM7.76467 3.17283H6.23533V7.76467H7.76467V3.17283Z"
      fill="#717D7E"
    />
  </svg>
);

export default SVGComponent;
